import { render, staticRenderFns } from "./SaldosFluxoDeCaixa.vue?vue&type=template&id=940b9a4a"
import script from "./SaldosFluxoDeCaixa.vue?vue&type=script&lang=js"
export * from "./SaldosFluxoDeCaixa.vue?vue&type=script&lang=js"
import style0 from "./SaldosFluxoDeCaixa.vue?vue&type=style&index=0&id=940b9a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports